import React, {
  RefObject,
  useCallback,
  KeyboardEvent,
} from 'react';
import CurrencyTextField from 'core/components/CurrencyTextField';
import {
  EditableRendererProps,
} from 'core/components/VirtualTable/types';

export default function EditableCurrencyField({
  onSubmit,
  onCancel,
  value,
  controlRef,
  props = {},
  onChange,
}: EditableRendererProps<number | string | null | undefined>) {
  const handleKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSubmit?.();
    } else if (e.key === 'Escape') {
      onCancel?.();
    }
  }, [onSubmit, onCancel]);

  return (
    <CurrencyTextField
      {...props}
      inputRef={controlRef as RefObject<HTMLInputElement>}
      allowNegative
      value={value}
      onChange={(value) => { onChange?.(value); }}
      onBlur={onSubmit}
      onKeyDown={handleKeyDown}
    />
  );
}
